export default "__VITE_ASSET__485e380c__"